import React from "react";
import styled from "styled-components";

export default styled.div`

    color: #6A6D90;
    font-size: 16px;
    line-height: 20px;
    
        display: ${(props) => (props.hidden ? "none" : "block")};
`;